import { useI18n } from "../../utils/translate/i18n/useI18n";
import TonalResultComponent from "./tonalResultComponent";
import ResultHeader from "../resultHeader/resultHeader";
import FormActionButton from "../formActionButton/formActionButton";
import type { TonalResultPanelProp } from "../../type/tonalTest";

export default function TonalResultPanel({
  result,
  resultPanelRef,
  exportMenuRef,
  panelClassName,
  subtitle,
  children,
  isExportMenuOpen,
  isExporting,
  exportFormat,
  isExportDisabled,
  showAnalysisButton = true,
  isAnalysisDisabled,
  onNewTest,
  onToggleExportMenu,
  onExport,
  onAnalyze,
  onEmailResult
}: TonalResultPanelProp) {
  const { t } = useI18n();

  return (
    <div
      ref={resultPanelRef}
      style={{
        display: "flex",
        flex: "1 1 0",
        flexDirection: "column",
        minHeight: 0
      }}
    >
      <TonalResultComponent
        className={panelClassName}
        header={(
          <ResultHeader
            pillText={t("Audiogram")}
            subtitle={subtitle}
            actionsRef={exportMenuRef}
            isExportMenuOpen={isExportMenuOpen}
            isExporting={isExporting}
            exportFormat={exportFormat}
            isExportDisabled={isExportDisabled}
            onToggleExportMenu={onToggleExportMenu}
            onExport={onExport}
            showAnalysisButton={showAnalysisButton}
            isAnalysisDisabled={isAnalysisDisabled}
            onAnalyze={onAnalyze}
            onEmailResult={onEmailResult}
            extraActions={
              onNewTest ? (
                <FormActionButton
                  type="button"
                  variant="secondary"
                  size="sm"
                  iconClassName="bi bi-arrow-repeat"
                  onClick={onNewTest}
                >
                  {t("Nowy test")}
                </FormActionButton>
              ) : undefined
            }
          />
        )}
        result={result}
      >
        {children}
      </TonalResultComponent>
    </div>
  );
}